import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('click', '.custom-dropdown__trigger', (e) => {
    $(e.target).closest('.custom-dropdown').toggleClass('custom-dropdown--active');
    return false;
  });

  $(document).on('change', '.custom-dropdown__input', (e) => {
    const $dropdown = $(e.target).closest('.custom-dropdown');
    $dropdown.removeClass('custom-dropdown--active');
    $dropdown.find('.custom-dropdown__option').removeClass('custom-dropdown__option--acitve');
    $dropdown
      .find('.custom-dropdown__trigger')
      .attr('class', 'custom-dropdown__trigger')
      .addClass(`custom-dropdown__trigger--${$(e.target).val().replace(/[_]/gim, '-')}`)
      .text($(e.target).closest('.custom-dropdown__option').text());
    $(e.target).closest('.custom-dropdown__option').addClass('custom-dropdown__option--acitve');
  });

  $('html').click(function (e) {
    const $target = $(e.target);
    if (!$target.is('.custom-dropdown__trigger')) {
      $('.custom-dropdown').removeClass('custom-dropdown--active');
    }
  });
});
